var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isSame
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loaded,
              expression: "loaded"
            }
          ],
          staticClass: "filter-item filter-item--price-filter"
        },
        [
          _c("h2", {
            staticClass: "filter-item__heading",
            domProps: { textContent: _vm._s(_vm.translations.title) }
          }),
          _vm._v(" "),
          _vm.showSlider
            ? _c("vue-slider", {
                attrs: {
                  min: _vm.minPrice,
                  max: _vm.maxPrice,
                  tooltip: false,
                  interval: _vm.interval,
                  debug: _vm.debug
                },
                model: {
                  value: _vm.priceSpan,
                  callback: function($$v) {
                    _vm.priceSpan = $$v
                  },
                  expression: "priceSpan"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "filter-item__flex" }, [
            _c("p", { staticClass: "filter-item__price-text" }, [
              _c("span", {
                directives: [
                  {
                    name: "price",
                    rawName: "v-price",
                    value: _vm.shownMinPrice,
                    expression: "shownMinPrice"
                  }
                ]
              }),
              _vm._v(" " + _vm._s(_vm.minPriceData.currency))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "filter-item__price-text" }, [
              _c("span", {
                directives: [
                  {
                    name: "price",
                    rawName: "v-price",
                    value: _vm.shownMaxPrice,
                    expression: "shownMaxPrice"
                  }
                ]
              }),
              _vm._v(" " + _vm._s(_vm.maxPriceData.currency))
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08bbb6b2", { render: render, staticRenderFns: staticRenderFns })
  }
}